module.exports = __webpack_public_path__ + "static/jinx_1280w_q50-29f89d799289db59f0ff64753dfeedca.webp";